module.exports = __webpack_public_path__ + "static/media/hear_results_1.b92e85c8.jpg";